import { TextField } from "../../../../components/TextField/TextField.tsx";
import { SettingsItemLayout } from "./SettingsItemLayout.tsx";

export const SettingsTextItem = ({
  title,
  value,
  onChange,
  type = "text",
  disabled = false,
}: {
  title: string;
  value: string | null;
  onChange: (value: string) => void;
  type?: "text" | "number";
  disabled?: boolean;
}) => (
  <SettingsItemLayout title={title}>
    <TextField
      size="md"
      value={value ?? ""}
      onChange={onChange}
      type={type}
      inputClassName={type === "number" ? "hide-controls" : undefined}
      className="w-[240px]"
      disabled={disabled}
    />
  </SettingsItemLayout>
);
